import * as React from 'react';
import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { IAttendeeOrganizationDTO } from '../../../../../../api/attendees.dao';
import { IOperatorDetailsDTO } from '../../../../../../api/rooms.dao';
import { OrganizationMultiSelectButton } from '../../../../../global/multi-select/organization-multi-select-button';
import { MultiSelectFilterType } from '../../../../../global/multi-select/make-multi-select-in-popover';

import './attendees-list.scss';
import { Organization } from './organization/organization';

interface IProps {
    onChange: (attendees: IAttendeeOrganizationDTO[]) => void;
    removeOrganization?: (id: number) => void;
    removeAttendee?: (id: number) => void;
    name: string;
    attendees: (IAttendeeOrganizationDTO | IOperatorDetailsDTO)[];
    selected: IAttendeeOrganizationDTO[];
    disabled: Record<number, Record<number, boolean>>;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ActionButton?: () => ReactElement;
    onClick?: () => void;
}

const AttendeesList = ({
       name,
       selected,
       disabled,
       onClick,
       onChange,
       attendees,
       ActionButton,
       removeAttendee,
       removeOrganization,
   }: IProps) => {

    return (
        <div className='attendee-list'>
            <div className='attendee-list__label'>
                <FormattedMessage id={`oe.input.${name}`} description='Input label' defaultMessage={name}/>
            </div>
            {selected?.slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(el => (
                    <Organization
                        name={el.name}
                        organization={el}
                        key={el.organizationId}
                        attendees={el.attendees}
                        removeAttendee={removeAttendee}
                        organizationId={el.organizationId}
                        removeOrganization={removeOrganization}
                    />
                ))}
            <OrganizationMultiSelectButton
                className='attendee-list__add-button'
                items={attendees}
                value={selected}
                disabled={disabled}
                keyProperty='organizationId'
                nameProperty='name'
                onChange={onChange}
                onClick={onClick}
                text={<FormattedMessage
                    id='oe.attendee.add'
                    description='Button text'
                    defaultMessage='+ Add {name}'
                    values={{
                        name: name
                    }}
                />}
                filterType={MultiSelectFilterType.Group}
                applyButtonText='Add'
                resetButtonText='Cancel'
                searchPlaceholder='Search'
                ActionButton={ActionButton}
            />
        </div>
    );
};

export { AttendeesList };
